import React, { FC } from 'react';
import { Image } from 'react-bootstrap';
import cn from 'classnames';
import styles from './ImageContainer.module.css';
import { Action } from '../../atoms';

interface ImageContainerProps {
  src: string | undefined;
  handleEdit: () => void;
  handleDelete: () => void;
}

const ImageContainer: FC<ImageContainerProps> = ({
  src,
  handleEdit,
  handleDelete,
}) => {
  return (
    <div className={cn(styles.imageContainerWrapper)}>
      <div className={cn(styles.imageWrapper)}>
        <Image className={cn(styles.image)} src={src} />
      </div>
      <div className={cn(styles.actionsWrapper)}>
        <Action type="edit" size="sm" onClick={handleEdit} />
        <Action type="delete" size="sm" onClick={handleDelete} />
      </div>
    </div>
  );
};

export default ImageContainer;
